export default __webpack_public_path__ + "static/media/user-feet.178e6791.svg";